<template>
  <div class="bq-banner" :class="classes">
    <div class="bq-banner-cover" v-if="!isMobile">
      <div class="banner-line" v-if="false">
        <div class="left-line line"></div>
        <!-- <div class="right-line line"></div> -->
      </div>
      <div class="bq-banner-content">
        <!-- 标题扩展 -->
        <h2 class="bq-banner-title" :class="animateTitle" v-if="title">
          <!-- <span v-for="item in title.split('')" :key="item">
            {{ item }}
          </span> -->
          <p class="bq-banner-title-text">{{ title }}</p>
          <p class="bq-banner-text">{{ subTitle }}</p>
        </h2>

        <!-- title 扩展 -->
        <slot name="title"></slot>

        <!-- content 扩展 -->
        <slot name="content"></slot>
        <div class="banner-img">
          <div class="canvas-wrap">
            <svg version="1.1" id="lineSvg">
              <path d="M 160 0 L 10 140 L 295 140 L 160 0 " />
            </svg>
            <canvas id="lineCanvas"></canvas>
          </div>
          <img
            src="https://img.alicdn.com/tfs/TB1ZTWyCxv1gK0jSZFFXXb0sXXa-700-626.png"
            alt="价值观"
          />
        </div>

        <!-- extra 扩展 -->
        <slot name="extra"></slot>
      </div>
    </div>
  </div>
</template>

<script>
// import { isWirelessDevice } from '../../../utils/utils';
import { TrackLine } from '../../../utils/cavas-line';

export default {
  name: 'BQBanner',

  props: {
    type: {
      type: String,
      default: 'vertical', // horizontal || vertical
    },
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      tpe: String,
      default: '',
    },
  },

  data() {
    return {
      isMobile: false,
      animateTitle: [],
    };
  },

  created() {
    // this.isMobile = isWirelessDevice();
  },

  mounted() {
    setTimeout(() => {
      this.animateTitle = ['animate-title'];
    }, 10);

    try {
      const svg = document.getElementById('lineSvg'),
        path = svg.lastElementChild,
        totalLength = Math.ceil(path.getTotalLength());
      const pointList = [];
      for (let i = 0; i < totalLength; i++) {
        const point = path.getPointAtLength(i);
        pointList.push([point.x, point.y]);
      }
      const options = {
        container: 'lineCanvas',
        isShowLine: false,
        isAnimate: true,
        radius: 2,
        speed: 2,
        data: [
          {
            turnPoints: null,
            pointList: pointList,
            fillStyle: 'rgba(255,255,255,.6)',
          },
        ],
      };
      new TrackLine(options);
    } catch (error) {
      console.log('object :>> ', error);
    }
  },

  computed: {
    classes() {
      const { type, isMobile } = this;

      return {
        [`bq-banner-${type}`]: type,
        mobile: isMobile,
      };
    },
  },

  methods: {},
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
